export default __webpack_public_path__ + "static/636-2729711568adb858862719c1e739f6ea.gif";